import { render } from "./VerifyViaTwitter.vue?vue&type=template&id=a1fdac12&scoped=true"
import script from "./VerifyViaTwitter.vue?vue&type=script&lang=js"
export * from "./VerifyViaTwitter.vue?vue&type=script&lang=js"

import "./VerifyViaTwitter.vue?vue&type=style&index=0&id=a1fdac12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1fdac12"]])

export default __exports__